module.exports = __webpack_public_path__ + "img/filosofia_e_sociologia.bf344668.svg";